import Validation from "utils/validation.utils";
import locale from "localization";
import { formatAmount, parseNumber } from "utils";

export const initialState = (
  state = {},
  {
    maximumPoints = 0,
    dailyRemainingLimit = null,
    weeklyRemainingLimit = null,
    monthlyRemainingLimit = null,
  } = {}
) => {
  const toNullableNumber = (value) => {
    if (value == null) {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const limits = [
    {
      remaining: toNullableNumber(dailyRemainingLimit),
      message: locale.yourRemainingDailyLimitIs,
    },
    {
      remaining: toNullableNumber(weeklyRemainingLimit),
      message: locale.yourRemainingWeeklyLimitIs,
    },
    {
      remaining: toNullableNumber(monthlyRemainingLimit),
      message: locale.yourRemainingMonthlyLimitIs,
    },
  ];

  const validateRemainingLimit = (field) => {
    const rawValue = field?.value?.toString().trim();
    if (!rawValue) {
      return { error: false, message: "" };
    }

    const points = Number(parseNumber(field.value));
    if (!Number.isFinite(points) || points <= 0) {
      return { error: false, message: "" };
    }

    const validLimits = limits.filter((item) => {
      return item.remaining != null;
    });

    const lowestLimit = validLimits.reduce((lowest, current) => {
      if (!lowest || current.remaining < lowest.remaining) {
        return current;
      }
      return lowest;
    }, null);

    const exceededLimit =
      lowestLimit && points > lowestLimit.remaining
        ? lowestLimit
        : null;

    if (!exceededLimit) {
      return { error: false, message: "" };
    }

    if (exceededLimit.remaining <= 0) {
      return {
        error: true,
        message: locale.yourCashInLimitHasBeenReached,
      };
    }

    return {
      error: true,
      message: locale.populate(exceededLimit.message, [formatAmount(exceededLimit.remaining)]),
    };
  };

  const {
    points = {
      value: "",
      name: "points",
      placeholder: "0",
      validations: [
        Validation.required(),
        Validation.min(1000, {
          customMessage: locale.populate(locale.minimumCashInVIPPoints, [formatAmount(1000)]),
          isFormatted: true,
        }),
        Validation.max(maximumPoints, {
          customMessage: locale.maximumCashInVIPPoints,
          isFormatted: true,
        }),
        validateRemainingLimit,
      ],
      required: true,
    },
  } = state;
  return {
    points,
  };
};
